const checkColor = (color: string) => {
  if (!/^#(?:(?:[0-9a-fA-F]{3}){1,2}|(?:[0-9a-fA-F]{4}){1,2})$/.test(color)) {
    return '#000000';
  }
  return color;
};

export default checkColor;
